(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-shop-by-need]';
  const MOBILE_MEDIA_QUERY = window.matchMedia('(max-width: 767px)');

  function initMobileDots(section) {
    if (!section || section.dataset.needDotsInitialized === 'true') return;

    const track = section.querySelector('.needGrid');
    const cards = Array.from(section.querySelectorAll('.needCard'));
    const dots = Array.from(section.querySelectorAll('.needSlider__dot'));

    if (!track || !cards.length || !dots.length) return;

    section.dataset.needDotsInitialized = 'true';

    let frameId = null;

    function getMaximumScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getCardTarget(card) {
      return Math.min(card.offsetLeft, getMaximumScroll());
    }

    function updateDots() {
      frameId = null;

      if (!MOBILE_MEDIA_QUERY.matches) return;

      let activeIndex = 0;
      let smallestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(track.scrollLeft - getCardTarget(card));

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function scheduleUpdate() {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(updateDots);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (!MOBILE_MEDIA_QUERY.matches || !cards[index]) return;

        track.scrollTo({
          left: getCardTarget(cards[index]),
          behavior: 'smooth'
        });
      });
    });

    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    MOBILE_MEDIA_QUERY.addEventListener('change', scheduleUpdate);

    updateDots();
  }

  function initAll(root = document) {
    if (root.matches?.(SECTION_SELECTOR)) initMobileDots(root);
    root.querySelectorAll?.(SECTION_SELECTOR).forEach(initMobileDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), {
      once: true
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
